import { render, staticRenderFns } from "./AccountType.vue?vue&type=template&id=51d286d6&scoped=true&"
import script from "./AccountType.vue?vue&type=script&lang=js&"
export * from "./AccountType.vue?vue&type=script&lang=js&"
import style0 from "./AccountType.vue?vue&type=style&index=0&id=51d286d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d286d6",
  null
  
)

export default component.exports